import { connect } from 'react-redux'
import { IStateProps, IDispatchProps } from './YumCustomEntry'
import { getProgress, refreshChallengeResults } from '../../views/Progress/store/ProgressActions'
import YumCustomEntry from './YumCustomEntry'
import { IGlobalState } from '../../Root/store/appReducer'
import { GoalWithProgress } from '../../services/api.types'
import {
  getAllDailyProgressSelector,
  getCustomProgressRawSelector,
  getCustomProgressSelector,
  getDailyProgressSelector,
  getManualEntryPointsLogicIdSelector,
  getManualEntryProgressTypeSelector,
  getProgressResultsSelector,
} from '../../views/Progress/store/progressSelectors'
import { getUserProgress } from '../../views/Activity/store/ActivitySelectors'
import { getUserDto } from '../../common/auth/authSelectors'
import { getCustomTypeWithLegacy } from '../../services/CustomTypes'

export interface IOwnProps {
  goal: GoalWithProgress
  showManualEntry?: boolean
  isNewLayout?: boolean
}

const mapStateToProps = (state: IGlobalState, ownProps: IOwnProps): IStateProps => {
  const { goal, showManualEntry, isNewLayout } = ownProps
  const goalId = goal.id
  return {
    goal,
    showManualEntry,
    isNewLayout,
    dailyDiary: getDailyProgressSelector(state, getCustomTypeWithLegacy(goal.customType, goal.progressType)),
    allDailyDiary: getAllDailyProgressSelector(state),
    customProgress: getCustomProgressSelector(state, goalId),
    allCustomProgress: getCustomProgressRawSelector(state, goalId),
    progressResults: getProgressResultsSelector(state),
    activityProgress: getUserProgress(state, goalId),
    userDto: getUserDto(state),
    manualEntryProgressType: getManualEntryProgressTypeSelector(state),
    manualEntryPointsLogicId: getManualEntryPointsLogicIdSelector(state),
  }
}

const mapDispatchToProps: IDispatchProps = {
  refreshChallengeResults,
  getProgress,
}

export default connect(mapStateToProps, mapDispatchToProps)(YumCustomEntry)
